export type WOAction = {
  label: string;
  buttonType: "primary" | "default";
  action:
    | "start"
    | "review"
    | "standby"
    | "done"
    | "confirm"
    | "reject"
    | "delay"
    | "continue";
};

type WOStatusTransition = {
  management: WOAction[];
  field: WOAction[];
};

// "standby" is the technician-reported pause (weather, logistics) that keeps the work
// order workable; "delay" is the manager-only hold for a client-side blocker (unpaid
// invoice, permit) that takes the work order away from its technicians entirely. Only
// management is ever offered delay/continue — the backend rejects both for technicians.
export const WO_STATUS_TRANSITIONS: Record<string, WOStatusTransition> = {
  NEW: {
    management: [
      { label: "Start Work Order", buttonType: "primary", action: "start" },
      { label: "Delay Work Order", buttonType: "default", action: "delay" },
    ],
    field: [{ label: "Start Work Order", buttonType: "primary", action: "start" }],
  },
  IN_PROGRESS: {
    management: [
      { label: "Mark In Review", buttonType: "primary", action: "review" },
      { label: "Report Standby", buttonType: "default", action: "standby" },
      { label: "Delay Work Order", buttonType: "default", action: "delay" },
    ],
    field: [
      { label: "Complete", buttonType: "primary", action: "done" },
      { label: "Report Standby", buttonType: "default", action: "standby" },
    ],
  },
  STANDBY: {
    management: [
      { label: "End Standby", buttonType: "primary", action: "start" },
      { label: "Delay Work Order", buttonType: "default", action: "delay" },
    ],
    field: [{ label: "End Standby", buttonType: "primary", action: "start" }],
  },
  DELAYED: {
    management: [
      { label: "Continue Work Order", buttonType: "primary", action: "continue" },
    ],
    field: [],
  },
  IN_REVIEW: {
    management: [
      { label: "Confirm", buttonType: "primary", action: "confirm" },
      { label: "Reject", buttonType: "default", action: "reject" },
    ],
    field: [],
  },
  DONE: {
    management: [],
    field: [],
  },
};
